import { types } from 'mobx-state-tree';

import { Contact as BaseContact, Address } from '../definitions/common';
import CREDIT_SCORES from '../definitions/CreditScores';
import Employment from './Employment';


const CreditCardContact = types
    .model({
        address: types.maybe(Address),

        creditScore: types.maybeNull(types.enumeration(Object.values(CREDIT_SCORES))),
        creditLimit: types.maybe(types.number),
        income: types.maybeNull(types.integer),
        sin: types.optional(types.string, ''),

        hasSubscribed: types.maybe(types.boolean),
        hasSavedResults: types.maybeNull(types.boolean),

        employment: types.maybe(Employment),

        monthlyRentOrMortgage: types.maybe(types.number),
    });

const Contact = types.compose('Contact', BaseContact, CreditCardContact);

export default Contact;
